<template>
  <div class="modal-mask" @mousedown.self.stop="closeModal">
    <div class="modal" @click.stop>
      <div class="modal__head">
        <h3 class="modal__title">{{ res ? (state.updatedId ? 'Обновление контролирующего лица' : 'Создание контролирующего лица') : (state.updatedId ? 'Обновление ответственного лица' : 'Создание ответственного лица')}}</h3>
        <div class="close" @click.stop="closeModal">
          <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 1L16 16" stroke="currentColor" stroke-width="2"/>
            <path d="M1 16L16 1" stroke="currentColor" stroke-width="2"/>
          </svg>
        </div>
      </div>
      <div class="modal__body">
        <div class="page__row mb-40">
          <AppSelect title="ФИО"
                     :options="options"
                     :value="value"
                     required
                     :valid="valid"
                     @value-changed="setItemSelect"
                     @open="clearValidation('control')"
          />
        </div>
        <div class="page__row mb-20" v-if="inOrder">
          <AppSelect title="Порядок"
                     :options="orderOptions"
                     :value="state.order"
                     @value-changed="setItemOrder"
          />
        </div>
        <div class="page__row mb-40" v-if="state.value && state.value.voting_date">
          <AppCheckbox title="Проголосовал"
                       :checked="state.value.voted"
                       @toggle-check="toggleCheck(state.value.voted)"
          />
        </div>
        <div class="modal__button-wrap">
          <div class="modal__button">
            <AppButton :title="state.updatedId == null ? 'Создать' : 'Обновить' " type="main" @click.native="saveItemInfo"/>
          </div>
          <div class="modal__button">
            <AppButton title="Отмена" type="alt" @click.native="closeModal"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppButton from '@/components/page/button/AppButton.vue'
import AppSelect from '@/components/page/input/AppSelect'
import AppCheckbox from '@/components/page/input/AppCheckbox'

export default {
  name: 'ApproveUpdateControlModal',
  components: {
    AppCheckbox,
    AppSelect,
    AppButton
  },
  props: {
    state: {
      type: Object,
      default: () => {}
    },
    res: {
      default: false,
      type: Boolean
    },
    options: Array,
    value: Object,
    valid: {
      type: Object,
      default: () => {
        return { type: null, message: '' }
      }
    },
    canVote: Object,
    inOrder: Boolean,
    orderOptions: Array
  },
  computed: {},
  methods: {
    setItemSelect (value) {
      this.$emit('set-item-select', value)
    },
    setItemOrder (value) {
      this.$emit('set-item-order', value)
    },
    saveItemInfo () {
      this.$emit('save-item-info')
    },
    clearValidation (inputName) {
      this.$emit('clear-validation', inputName)
    },
    closeModal () {
      this.$emit('close-modal')
    },
    toggleCheck (value) {
      this.$emit('toggle-check', value)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/css/system/_vars';
@import '../../assets/css/system/_mixins';

.modal {
  max-width: 500px;

  &__text {
    text-align: center;
    color: $font_color_second;
    margin-bottom: 20px;
  }

  &__button-wrap {
    display: flex;
    flex-flow: row wrap;
    justify-content: center;
  }

  &__button {
    margin-right: 16px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
